export default {
  path: 'manage-expenses',
  component: () => import('@/views/Route'),
  children: [
    {
      path: '',
      name: 'Manage Expenses',
      component: () => import('@/views/menus/expenses/Index'),
      meta: {
        permission: true
      }
    }
  ]
}
